class TechnicalModel{

}

export {TechnicalModel}